var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 23,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_164_3518)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 2361,
    transform: "translate(-131 -1247)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_164_3518)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -31,
    y: -417,
    width: 1720,
    height: 754,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -30.5,
    y: -416.5,
    width: 1719,
    height: 753,
    rx: 9.5,
    stroke: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11 21.5C16.5228 21.5 21 17.0228 21 11.5C21 5.97715 16.5228 1.5 11 1.5C5.47715 1.5 1 5.97715 1 11.5C1 17.0228 5.47715 21.5 11 21.5Z",
    stroke: "#989898",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7155 19.7069C13.132 18.7598 16.9744 16.4078 15.5565 14.6353C14.9284 13.8502 13.3294 12.6312 14.1222 11.2705C15.3853 9.10248 20.769 9.7794 21.0012 11.5075",
    stroke: "#989898",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.23743 18.867C5.28523 17.9086 6.30003 16.9694 6.82034 15.7144C7.25756 14.6599 7.82225 13.2373 7.16112 12.3067C6.55434 11.4525 4.65788 12.4624 4.10492 11.5724C3.64079 10.8255 3.95284 9.16924 4.6885 8.9996C5.91255 8.71733 8.14237 10.4017 7.74289 8.81729C5.96841 4.91524 8.63099 5.78561 6.71374 2.46484",
    stroke: "#989898",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0977 7.3506C19.4453 6.93773 18.3567 6.54894 17.1865 6.61293C16.0163 6.67692 13.5673 8.07521 13.0207 6.79725C12.3569 5.24552 14.3823 3.0983 16.676 3.29369",
    stroke: "#989898",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_164_3518",
    x: -51,
    y: -433,
    width: 1760,
    height: 794,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_164_3518"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_164_3518",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_164_3518"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 2361,
    fill: "white",
    transform: "translate(-131 -1247)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeIcon);
export default __webpack_public_path__ + "static/media/globeIcon.a076b52d03e4c88a131be13e8b809e77.svg";
export { ForwardRef as ReactComponent };